export default __webpack_public_path__ + "9c25b7f47eb96754aa1a1a935a2685c8.png";